import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import {
  FontAwesomeModule,

} from '@fortawesome/angular-fontawesome';

import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FullCalendarModule } from '@fullcalendar/angular';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectFilterModule } from 'mat-select-filter';
import { MatSortModule } from '@angular/material/sort';
// import { AppRoutingModule } from '../app-routing.module';



@NgModule({
  imports: [
    MatSelectFilterModule,
    MatTooltipModule,
    MatFormFieldModule,
    TranslateModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    FormsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MaterialFileInputModule,
    MatCardModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatStepperModule,
    MatButtonModule,
    FontAwesomeModule,
    // NgxEventCalendarModule,
    FullCalendarModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule
  ],
  declarations: [

  ],
  exports: [
    MatTooltipModule,
    MatFormFieldModule,
    TranslateModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    FormsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MaterialFileInputModule,
    MatCardModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatStepperModule,
    MatButtonModule,
    FontAwesomeModule,
    MatSnackBarModule,
    // NgxEventCalendarModule,
    FullCalendarModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatSelectFilterModule,
    MatSortModule
  ]
})
export class MaterialDesignModule {

}
